import React, { Component } from 'react'
import Select from 'react-select'
import { GatsbyImage } from 'gatsby-plugin-image'

import { QtyMinus, QtyPlus, ArrowLeft, Close } from './icons'

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

const rentRangeMin = [
  { label: "$0", value: 0 },
  { label: "$100", value: 100 },
  { label: "$200", value: 200 },
  { label: "$300", value: 300 },
  { label: "$400", value: 400 },
  { label: "$500", value: 500 },
  { label: "$600", value: 600 },
  { label: "$700", value: 700 },
  { label: "$800", value: 800 },
  { label: "$900", value: 900 },
  { label: "$1,000", value: 1000 },
]

const rentRangeMax = [
  { label: "$0", value: 0 },
  { label: "$100", value: 100 },
  { label: "$200", value: 200 },
  { label: "$300", value: 300 },
  { label: "$400", value: 400 },
  { label: "$500", value: 500 },
  { label: "$600", value: 600 },
  { label: "$700", value: 700 },
  { label: "$800", value: 800 },
  { label: "$900", value: 900 },
  { label: "$1,000", value: 1000 },
  { label: "$1,500", value: 1500 },
  { label: "$2,000", value: 99999 },
]

const priceRangeMin = [
  { label: "$100,000", value: 100000 },
  { label: "$200,000", value: 200000 },
  { label: "$300,000", value: 300000 },
  { label: "$400,000", value: 400000 },
  { label: "$500,000", value: 500000 },
  { label: "$600,000", value: 600000 },
  { label: "$700,000", value: 700000 },
  { label: "$800,000", value: 800000 },
  { label: "$900,000", value: 900000 },
  { label: "$1,000,000", value: 1000000 },
  { label: "$1,500,000", value: 1500000 },
  { label: "$2,000,000", value: 2000000 },
  { label: "$2,500,000", value: 2500000 },
  { label: "$3,000,000", value: 3000000 },
  { label: "$3,500,000", value: 3500000 },
  { label: "$4,000,000", value: 4000000 },
]

const priceRangeMax = [
  { label: "$500,000", value: 500000 },
  { label: "$600,000", value: 600000 },
  { label: "$700,000", value: 700000 },
  { label: "$800,000", value: 800000 },
  { label: "$900,000", value: 900000 },
  { label: "$1,000,000", value: 1000000 },
  { label: "$1,500,000", value: 1500000 },
  { label: "$2,000,000", value: 2000000 },
  { label: "$2,500,000", value: 2500000 },
  { label: "$3,000,000", value: 3000000 },
  { label: "$3,500,000", value: 3500000 },
  { label: "$4,000,000", value: 4000000 },
  { label: "$4,500,000", value: 4500000 },
  { label: "$5,000,000", value: 5000000 },
  { label: "$5,500,000", value: 5500000 },
  { label: "$6,000,000", value: 6000000 },
  { label: "$6,500,000", value: 6500000 },
  { label: "$7,000,000", value: 7000000 },
  { label: "$7,500,000", value: 7500000 },
  { label: "$8,000,000", value: 8000000 },
  { label: "$8,500,000", value: 8500000 },
  { label: "$9,000,000", value: 9000000 },
  { label: "$9,500,000", value: 9500000 },
  { label: "$10,000,000", value: 100000000 },
]

const propertyTypes = [
  {
    "id":"1","type":"Residential","categories":[
      {"id":"26","name":"Acreage"},{"id":"1","name":"Apartment"},{"id":"11","name":"Block Of Units"},{"id":"4","name":"House"},{"id":"5","name":"Land"},{"id":"8","name":"Semi\/Duplex"},{"id":"10","name":"Studio"},{"id":"12","name":"Terrace"},{"id":"13","name":"Townhouse"},{"id":"14","name":"Unit"},{"id":"15","name":"Villa"}
    ]
  },
  {
    "id":"2","type":"Commercial","categories":[
      {"id":"45","name":"Car Space"},{"id":"2","name":"Development"},{"id":"3","name":"Factory"},{"id":"27","name":"Hotel\/Leisure"},{"id":"5","name":"Land"},{"id":"28","name":"Medical\/Consulting"},{"id":"25","name":"Mixed Farming"},{"id":"6","name":"Office"},{"id":"29","name":"Other"},{"id":"9","name":"Retail"},{"id":"17","name":"Showroom"},{"id":"16","name":"Warehouse"}
    ]
  },
  /*
  {
    "id":"3","type":"Rural","categories":[
      {"id":"26","name":"Acreage"},{"id":"18","name":"Cropping"},{"id":"19","name":"Dairy"},{"id":"20","name":"Farmlet"},{"id":"21","name":"Horticulture"},{"id":"4","name":"House"},{"id":"5","name":"Land"},{"id":"22","name":"Lifestyle"},{"id":"23","name":"Livestock"},{"id":"25","name":"Mixed Farming"},{"id":"29","name":"Other"},{"id":"13","name":"Townhouse"},{"id":"15","name":"Villa"},{"id":"24","name":"Viticulture"}
    ]
  },
  {
    "id":"4","type":"Business","categories":[
      {"id":"46","name":"Accommodation\/Tourism"},{"id":"47","name":"Automotive"},{"id":"48","name":"Beauty\/Health"},{"id":"52","name":"Education\/Training"},{"id":"49","name":"Food\/Hospitality"},{"id":"53","name":"Franchise"},{"id":"54","name":"Home\/Garden"},{"id":"50","name":"Import\/Export\/Whole"},{"id":"55","name":"Industrial\/Manufacturing"},{"id":"56","name":"Leisure\/Entertainment"},{"id":"57","name":"Professional"},{"id":"9","name":"Retail"},{"id":"58","name":"Rural"},{"id":"51","name":"Services"},{"id":"59","name":"Transport\/Distribution"}
    ]
  },
  {
    "id":"5","type":"Holiday","categories":[
      {"id":"30","name":"Alpine"},{"id":"1","name":"Apartment"},{"id":"31","name":"BackpackerHostel"},{"id":"32","name":"BedAndBreakfast"},{"id":"33","name":"Campground"},{"id":"34","name":"CaravanHolidayPark"},{"id":"35","name":"ExecutiveRental"},{"id":"36","name":"FarmStay"},{"id":"37","name":"Flat"},{"id":"4","name":"House"},{"id":"38","name":"HouseBoat"},{"id":"39","name":"Lodge"},{"id":"40","name":"Motel"},{"id":"29","name":"Other"},{"id":"41","name":"Resort"},{"id":"42","name":"Retreat"},{"id":"43","name":"SelfContainedCottage"},{"id":"8","name":"Semi\/Duplex"},{"id":"44","name":"ServicedApartment"},{"id":"10","name":"Studio"},{"id":"12","name":"Terrace"},{"id":"13","name":"Townhouse"},{"id":"14","name":"Unit"}]
  }
  */
]

class ContactForm extends Component {

  constructor(props) {
    super(props)
    this.form = React.createRef()
    this.state = {
      popup: true,
      alerts: 'off',
      subscriptions: [],

      bedrooms: 0,
      bathrooms: 0,
      carparks: 0,
      errors: {},
    }
  }

  componentDidMount() {
    // https://cobden.atollon.com.au/wp-json/team/v1/subscriptions
    fetch(`https://cobden.atollon.com.au/wp-json/team/v1/subscriptions`)
      .then(res => res.json())
      .then((res) => {
        if (res?.response?.subscriptions) {
          this.setState({ subscriptions: res.response.subscriptions.filter(el => el.webDisplay) })
        }
      })
  }

  validateForm = () => {
    const errors = {};
    const { firstname, lastname, email, mobile, looking_for, type, suburbs, price_min, price_max, subscriptions, bedrooms, bathrooms, carparks } = this.state;

    if (!firstname) errors.firstname = "First name is required.";
    if (!lastname) errors.lastname = "Last name is required.";
    if (!email) errors.email = "Email is required.";
    if (!mobile) errors.mobile = "Contact number is required.";
    if (!looking_for) errors.looking_for = "Please select an option.";
    if (!type) errors.type = "Please select a property type.";
    if (!suburbs) errors.suburbs = "Please enter suburbs.";
    if (!price_min || !price_max) errors.price = "Please select a price range.";
    if (!subscriptions.some(sub => sub.checked)) {
      errors.subscriptions = "Select at least one subscription.";
    }
    // Bed, Bath, Car validation: At least one must be selected
    if (bedrooms === 0 && bathrooms === 0 && carparks === 0) {
      errors.bedBathCar = "Select at least one bedroom, bathroom, or carpark.";
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubscriptionChange = e => {
    let { checked, value } = e.target
    let { subscriptions } = this.state
    let subscription = subscriptions.find(el => el.name === value)
    subscription.checked = checked
    this.setState({ subscriptions })
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value }, () => {
      if (e.target.name === 'type') {
        this.setState({ type_category: '' })
      }
    })
  }

  handleSubmit = e => {
    e.preventDefault()

    this.setState({ loading: true })

    if (!this.form.current.checkValidity()) {
      return this.setState({ loading: false })
    }

    if (!this.validateForm()) {
      this.setState({ loading: false });
      return;
    }

    let message = `
      Register for alerts submission

      Name: ${this.state.firstname} ${this.state.lastname}
      Email: ${this.state.email}
      Phone: ${this.state.mobile}

      Looking to: ${this.state.looking_for}
      Type: ${this.state.type}

      Suburbs: ${this.state.suburbs}
      Include surrounding suburbs: ${this.state.surrounding_suburbs}

      Bedrooms: ${this.state.bedrooms}
      Bathrooms: ${this.state.bathrooms}
      Carparks: ${this.state.carparks}

      Price range: ${this.state.price_min?.value} - ${this.state.price_max?.value}

      I would like to recieved:
      ${this.state.subscriptions.map(el => el.checked ? el.name : '').join('\n')}
    `

    let body_object = JSON.parse(JSON.stringify(this.state)); 

    body_object.subscriptions = this.state.subscriptions.filter(el => el.checked).map(el => el.name).join(', ')

    body_object.price_min = this.state.price_min?.value
    body_object.price_max = this.state.price_max?.value
    body_object.message = message

    fetch(`https://cobden.atollon.com.au/wp-json/team/v1/search-requirements`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode(body_object)
    })
    .then(res => res.json())
    .then((res) => {
      if (res?.response?.status === 'success') {
        return this.setState({ result: "success", loading: false })
      }
      if (res?.response?.errors) {
        this.setState({
          loading: false,
          result: 'fail',
          msg: res.response.errors.map(err => err.detail.split('\n').map((el, i) => <div key={i}>{ el }</div>))
        })
      }
    })
    .catch(error => this.setState({result: 'fail', msg: error, loading: false}))

  }

  handleSelectChange = (option, field) => {
    let state = {}

    let results = []

    if (field.name === 'category') {
      state['action'] = `/${option.value}/`
      if (this.props.home) {
        if (option.value === 'for-lease') {
          this.props.lease.forEach((el, i) => {
            results.push({
              title: el.title,
            })
          })
        }
        if (option.value === 'sold') {
          this.props.sold.forEach((el, i) => {
            results.push({
              title: el.title,
            })
          })
        }
        if (option.value === 'for-sale') {
          this.props.forSale.forEach((el, i) => {
            results.push({
              title: el.title,
            })
          })
        }
        this.props.staff.allWpTeam.nodes.forEach((el, i) => {
          results.push({
            title: el.title,
          })
        })
        this.setState({ results }, this.autoComplete)
      }
    }
    switch (field && field.action) {
      case 'select-option':
        state[field.name] = option
        break
      case 'mount':
        let { name, value } = option.currentTarget
        let item = this[name]?.props?.options?.find(el => el.value === value)
        if (item) {
          state[name] = item
        }
        break
      default:
        state[option.currentTarget.name] = option.currentTarget.value
        break
    }
    this.setState(state)
  }

  handleBedrooms = (operator) => {
    let { bedrooms } = this.state
    if (operator === 'plus') {
      bedrooms = bedrooms + 1
      if (bedrooms > 10) bedrooms = 10
    } else {
      bedrooms = bedrooms - 1
      if (bedrooms < 0) bedrooms = 0
    }
    this.setState({ bedrooms }, this.updateList)
  }
  handleBaths = (operator) => {
    let { bathrooms } = this.state
    if (operator === 'plus') {
      bathrooms = bathrooms + 1
      if (bathrooms > 10) bathrooms = 10
    } else {
      bathrooms = bathrooms - 1
      if (bathrooms < 0) bathrooms = 0
    }
    this.setState({ bathrooms }, this.updateList)
  }
  handleCars = (operator) => {
    let { carparks } = this.state
    if (operator === 'plus') {
      carparks = carparks + 1
      if (carparks > 10) carparks = 10
    } else {
      carparks = carparks - 1
      if (carparks < 0) carparks = 0
    }
    this.setState({ carparks }, this.updateList)
  }

  render() {
    let props = {
      ref: this.form,
      name: 'register',
      className: 'form',
      onSubmit: this.handleSubmit,
    }

    let { looking_for, errors, msg } = this.state

    if (this.state.result === 'success') {
      return (
        <div className={`modal${this.state.popup ? ' active' : ''}`}>
          <div className='modal__close-bg' onClick={() => this.setState({ popup: false })} />
          <div className='modal__inner'>
            <button className='modal__close' onClick={() => this.setState({ popup: false })}>
              <Close color='#000000' />
            </button>
            <div className='modal__wrapper'>
              <div className='modal__thank'>
                <h2>Your message has been sent.<br />
                Thanks for registering for property alerts. Keep an eye out on your inbox.</h2>
              </div>
            </div>
          </div>
        </div>
      )
    }


    const typeCategory = propertyTypes.find(({ type }) => type === this.state.type)?.categories

    return (
      <form {...props}>
        <p>Register with us today.</p>

        <div className='form__row form__row--double'>
          <div className='form__item'>
            <label htmlFor='email'>First Name</label>
            <input
              type='text'
              name='firstname'
              onChange={this.handleChange}
              required
            />
            {errors.firstname && <span className="error">{errors.firstname}</span>}
          </div>
          <div className='form__item'>
            <label htmlFor='email'>Last Name</label>
            <input
              type='text'
              name='lastname'
              onChange={this.handleChange}
              required
            />
            {errors.lastname && <span className="error">{errors.lastname}</span>}
          </div>
        </div>

        <div className='form__row form__row--double'>
          <div className='form__item'>
            <label htmlFor='email'>Email</label>
            <input
              type='email'
              name='email'
              onChange={this.handleChange}
              required
            />
            {errors.email && <span className="error">{errors.email}</span>}
          </div>
          <div className='form__item'>
            <label htmlFor='phone'>Contact Number</label>
            <input
              type='text'
              name='mobile'
              onChange={this.handleChange}
              required
            />
            {errors.mobile && <span className="error">{errors.mobile}</span>}
          </div>
        </div>

        <div className='form__row form__row--double'>
          <p>I am looking to?</p>

          <div className='form__radio'>
            <input type='radio' name='looking_for' value='buy' id='checkbox_buy' onChange={this.handleChange} />
            <label htmlFor='checkbox_buy'><span>Buy</span></label>
          </div>

          <div className='form__radio'>
            <input type='radio' name='looking_for' value='rent' id='checkbox_rent' onChange={this.handleChange} />
            <label htmlFor='checkbox_rent'><span>Rent</span></label>
          </div>

          {errors.looking_for && <span className="error">{errors.looking_for}</span>}
        </div>

        <div className='form__row form__row--double'>
          <p>Type</p>

          { propertyTypes.map((el, i) => (
            <div className='form__radio' key={i}>
              <input type='radio' name='type' value={el.type} id={`checkbox_${el.type}`} onChange={this.handleChange} />
              <label htmlFor={`checkbox_${el.type}`}><span>{ el.type }</span></label>
            </div> 
          ))}

          {errors.type && <span className="error">{errors.type}</span>}
        </div>

        <div className='form__row form__row--double form__row--grid'>
          { typeCategory && <p>Category</p> }
          
          { typeCategory?.map((el, i) => (
            <div className='form__checkbox' key={i}>
              <input type='checkbox' name={'type_category'} value={el.name} id={`category_${el.name}`} onChange={this.handleChange} />
              <label htmlFor={`category_${el.name}`}><span>{ el.name }</span></label>
            </div>
          )) }

        </div>

        <div className='form__row form__row--suburb'>
          <div className='form__item'>
            <label htmlFor='suburbs'>Suburbs. <small>(Comma separated)</small></label>
            <input
              type='text'
              name='suburbs'
              id='suburbs'
              onChange={this.handleChange}
            />
            {errors.suburbs && <span className="error">{errors.suburbs}</span>}
          </div>
          <div className='form__checkbox'>
            <input type='checkbox' name='surrounding_suburbs' value='true' id='checkbox_surrounding_suburbs' onChange={this.handleChange} />
            <label htmlFor='checkbox_surrounding_suburbs'><span>Include surrounding suburbs</span></label>
          </div>
        </div>

        <div className='form__row form__row--double'>
          <div className='form__number form__select--bed'>
            <label>Beds</label>
            <button type='button' className='form__number-minus' onClick={() => this.handleBedrooms('minus')}>
              <QtyMinus />
            </button>
            <input className='form__number-input' type="number" name="bedrooms" value={this.state.bedrooms} min="0" max="10" readOnly />
            <button type='button' className='form__number-plus' onClick={() => this.handleBedrooms('plus')}>
              <QtyPlus />
            </button>
          </div>
          <div className='form__number form__select--bath'>
            <label>Baths</label>
            <button type='button' className='form__number-minus' onClick={() => this.handleBaths('minus')}>
              <QtyMinus />
            </button>
            <input className='form__number-input' type="number" name="bathrooms" value={this.state.bathrooms} min="0" max="10" readOnly />
            <button type='button' className='form__number-plus' onClick={() => this.handleBaths('plus')}>
              <QtyPlus />
            </button>
          </div>
          <div className='form__number form__select--car'>
            <label>Cars</label>
            <button type='button' className='form__number-minus' onClick={() => this.handleCars('minus')}>
              <QtyMinus />
            </button>
            <input className='form__number-input' type="number" name="carparks" value={this.state.carparks} min="0" max="10" readOnly />
            <button type='button' className='form__number-plus' onClick={() => this.handleCars('plus')}>
              <QtyPlus />
            </button>
          </div>
          <div>
            {errors.bedBathCar && <span className="error">{errors.bedBathCar}</span>}
          </div>
        </div>

        <div className='form__row form__row--double'>
          <p>Price range</p>
          
          <div className='form__select form__select--price-range'>
            <Select
              options={ (looking_for === 'buy' || !looking_for) ? priceRangeMin : rentRangeMin }
              onChange={this.handleSelectChange}
              openMenuOnFocus={true}
              isSearchable={false}
              id="price_min"
              name="price_min"
              value={this.state.price_min}
              placeholder="$ Low"
              className="react-select-container"
              classNamePrefix="react-select"
              ref={node => this.price_min = node}
            />
          </div>

          <div className='form__select form__select--price-range'>
            <Select
              options={ (looking_for === 'buy' || !looking_for) ? priceRangeMax : rentRangeMax }
              onChange={this.handleSelectChange}
              openMenuOnFocus={true}
              isSearchable={false}
              id="price_max"
              name="price_max"
              value={this.state.price_max}
              placeholder="$ High"
              className="react-select-container"
              classNamePrefix="react-select"
              ref={node => this.price_max = node}
            />
          </div>
          {errors.price && <span className="error">{errors.price}</span>}
        </div>

        <div className='form__row form__row--double form__row--grid'>
          <p>I would like to recieve</p>

          { this.state.subscriptions?.map((el, i) => {
            const _id = el.name.toLowerCase().replace(/ /gi, '_')
            return (
              <div className='form__checkbox' key={i}>
                <input type='checkbox' name={_id} value={el.name} id={_id} onChange={this.handleSubscriptionChange} />
                <label htmlFor={_id}><span>{ el.name }</span></label>
              </div>
            )
          })}

          {errors.subscriptions && <span className="error">{errors.subscriptions}</span>}

        </div>

        {msg && 
          <div className='form__row'>
            <div className='error'>{msg}</div>
          </div>
        }

        <div className='form__row form__row--submit'>
          <button type='submit' className='btn' disabled={this.state.loading}>
            <span>{ this.state.loading ? 'Validating submission...' : 'Register for Alerts' }</span>
          </button>
        </div>
      </form>
    )
  }
}

const RegisterForAlerts = ({ title, image }) => {

  return (
    <section className='register-for-alerts'>
      <div className='register-for-alerts__back'>
        <button onClick={() => window && window.history.back()}>
          <ArrowLeft color='#0F2130' />
          Back
        </button>

        {title && <h1>{title}</h1>}
      </div>

      <div className='register-for-alerts__inner'>
        <div className='register-for-alerts__form'>
          {title && <h1>{title}</h1>}

          <ContactForm />
        </div>

        <div className='register-for-alerts__image'>
          {image?.localFile && <GatsbyImage image={image.localFile.childImageSharp.gatsbyImageData} alt='' />}
        </div>
      </div>
    </section>
  )
}

export default RegisterForAlerts 